import { usePromotion } from '@mc/promo-utils'

export interface HeroImage {
  firstColumn: string
  secondColumn: string
}

export const useHomePagePromoHeroImages = (
  defaultImages: HeroImage[],
): HeroImage[] => {
  const { variables } = usePromotion()
  const promoImages = variables?.home_page_hero_images as HeroImage[]

  if (Array.isArray(promoImages) && promoImages.length > 0) {
    return promoImages
  }

  return defaultImages
}
